import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addToast } from 'store/toastsSlice';
const useCopyToClipboard = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    return (text, toast) => {
        navigator.clipboard.writeText(text).then(() => {
            var _a, _b;
            dispatch(addToast({
                color: (_a = toast === null || toast === void 0 ? void 0 : toast.color) !== null && _a !== void 0 ? _a : 'positive',
                title: (_b = toast === null || toast === void 0 ? void 0 : toast.title) !== null && _b !== void 0 ? _b : t('COPY_URL_SUCCESS'),
                description: toast === null || toast === void 0 ? void 0 : toast.description,
            }));
        });
    };
};
export default useCopyToClipboard;
